module.exports = __webpack_public_path__ + "img/1.febf940a.png";